import { RoundRecap } from '@/features/game-round/ui/RoundRecap';
import { JoinOnlineDialog } from '@/features/room-lobby/ui/JoinOnlineDialog';
import { HostSettingsSheet } from '@/shared/ui/HostSettingsSheet';
import { LanguagePickerSheet } from '@/shared/ui/LanguagePickerSheet';
import { MugshotEditor } from '@/shared/ui/mugshot/MugshotEditor';
import { PauseMenu } from '@/shared/ui/PauseMenu';
import { RulesSheet } from '@/shared/ui/RulesSheet';
import { SettingsSheet } from '@/shared/ui/SettingsSheet';
import type { DialogKind, DialogPropsMap } from './types';

/**
 * Maps dialog kind → React component. DialogHost looks up the component
 * here for each entry on the dialog stack and forwards props + onClose.
 *
 * Each component receives `{ open: true, onClose }` plus its registered
 * props row from `DialogPropsMap`. `open` is hardcoded `true` because
 * mounted in DialogHost == in the stack == open; close is driven by
 * removing the entry, not toggling the prop.
 */
export type DialogComponentProps<K extends DialogKind> = DialogPropsMap[K] & {
  open: true;
  onClose: () => void;
};

type AnyDialogComponent = (props: DialogComponentProps<DialogKind>) => React.ReactNode;

export const DIALOG_REGISTRY: Record<DialogKind, AnyDialogComponent> = {
  rules: RulesSheet as AnyDialogComponent,
  settings: SettingsSheet as AnyDialogComponent,
  pause: PauseMenu as AnyDialogComponent,
  'host-settings': HostSettingsSheet as AnyDialogComponent,
  mugshot: MugshotEditor as AnyDialogComponent,
  recap: RoundRecap as AnyDialogComponent,
  'join-online': JoinOnlineDialog as AnyDialogComponent,
  'language-picker': LanguagePickerSheet as AnyDialogComponent,
};
